import React, { useEffect, useRef, useState } from "react";
import { RiSearchLine } from "react-icons/ri";

import CreateButton from "../../../../Partials/Layouts/CRUDs/CRUDHeader/CreateButton/CreateButton";
import CRUDTable from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTable";
import CRUDTableHeader from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDTableHeader";
import CRUDth from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDth/CRUDth";
import CRUDTableRow from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableRow/CRUDTableRow";
import ShortTextCell from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell";

import ViewButton from "../../../../Partials/Layouts/CRUDs/CRUDButtons/ViewButton/ViewButton";
import EditButton from "../../../../Partials/Layouts/CRUDs/CRUDButtons/EditButton/EditButton";
import DeleteButton from "../../../../Partials/Layouts/CRUDs/CRUDButtons/DeleteButton/DeleteButton";

import DeleteItem from "../../../../Partials/Layouts/DeleteItem/DeleteItem";
import Modal from "../../../../Partials/Elements/Modal/Modal";
import Pagination from "../../../../Partials/Elements/pagination/Pagination";

import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance";
import { BUNDLE_OFFERS_API } from "../../../../../Utilities/APIs/APIs";

import CreateBundleOffer from "./CreateBundleOffer";
import UpdateBundleOffer from "./UpdateBundleOffer";
import ViewBundleOffer from "./ViewBundleOffer";

function BundleOffers() {
  const axiosInstance = useAxiosInstance();

  const [bundleOffers, setBundleOffers] = useState([]);

  const screenHeaderRef = useRef();
  const [screenHeaderHeight, setScreenHeaderHeight] = useState(0);

  const [limit] = useState(40);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");

  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showViewSection, setShowViewSection] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [showDeleteSection, setShowDeleteSection] = useState(false);

  const [toggleFetch, setToggleFetch] = useState(false);
  const [targetID, setTargetID] = useState(null);

  useEffect(() => {
    if (screenHeaderRef.current) {
      setScreenHeaderHeight(
        screenHeaderRef.current.clientHeight
      );
    }
  }, []);

  useEffect(() => {
    async function fetchBundleOffers() {
      try {
        const res = await axiosInstance.get(
          `${BUNDLE_OFFERS_API}?search=${search}&page=${currentPage}&limit=${limit}`
        );

        setBundleOffers(res?.data?.offers || []);
        setTotalItems(res?.data?.totalItems || 0);
      } catch (error) {
        console.error(
          "Failed to fetch bundle offers:",
          error
        );
      }
    }

    fetchBundleOffers();
  }, [
    axiosInstance,
    search,
    currentPage,
    limit,
    toggleFetch,
  ]);

  function triggerFetch() {
    setToggleFetch((prev) => !prev);
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSearch(searchInput);
      setCurrentPage(1);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchInput]);

  const formatAppliesTo = (value) => {
    const labels = {
      all: "All Products",
      products: "Selected Products",
      category: "Categories",
      brand: "Brands",
      collection: "Collections",
      productGroup: "Product Groups",
    };

    return labels[value] || value;
  };

  return (
    <>
      <div
        ref={screenHeaderRef}
        className="screen_header"
      >
        <div>
          <h1 className="screen_heading">
            Bundle Offers ({totalItems} in total)
          </h1>

          <p
            style={{
              fontSize: "13px",
              opacity: 0.7,
              marginTop: "4px",
            }}
            className="screen_heading"
          >
            Create automatic multi-buy discounts.
          </p>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <input
              value={searchInput}
              onChange={(e) =>
                setSearchInput(e.target.value)
              }
              className="input_field"
              placeholder="Search bundle offers"
              style={{ width: "400px" }}
            />

            <RiSearchLine
              style={{
                width: "30px",
                height: "30px",
                marginLeft: "-50px",
                color: "var(--white-2)",
              }}
            />
          </div>

          <CreateButton
            screenTopicSingular="Bundle Offer"
            setShowCreateForm={setShowCreateForm}
          />
        </div>
      </div>

      <CRUDTable
        screenHeaderHeight={screenHeaderHeight}
      >
        <CRUDTableHeader>
          <CRUDth th="Offer Name" />
          <CRUDth th="Applies To" />
          <CRUDth th="Buy" />
          <CRUDth th="Discount" />
          <CRUDth th="Status" />
          <CRUDth th="Actions" />
        </CRUDTableHeader>

        <tbody>
          {bundleOffers?.map((offer) => (
            <CRUDTableRow key={offer._id}>
              <ShortTextCell text={offer?.name} />

              <ShortTextCell
                text={formatAppliesTo(
                  offer?.appliesTo
                )}
              />

              <ShortTextCell
                text={`${offer?.requiredQuantity || 0} items`}
              />

              <ShortTextCell
                text={
                  offer?.discountType === "percentage"
                    ? `${offer?.discountValue || 0}%`
                    : `৳${offer?.discountValue || 0}`
                }
              />

              <ShortTextCell
                text={
                  offer?.isActive
                    ? "Active"
                    : "Inactive"
                }
              />

              <td>
                <div className="action_buttons_wrapper">
                  <div className="action_buttons">
                    <ViewButton
                      setShowViewSection={
                        setShowViewSection
                      }
                      targetID={offer._id}
                      setTargetID={setTargetID}
                      tooltipName="View"
                      tooltipContent="View"
                    />

                    <EditButton
                      setShowUpdateForm={
                        setShowUpdateForm
                      }
                      targetID={offer._id}
                      setTargetID={setTargetID}
                      tooltipName="Edit"
                      tooltipContent="Edit"
                    />

                    <DeleteButton
                      setShowDeleteSection={
                        setShowDeleteSection
                      }
                      targetID={offer._id}
                      setTargetID={setTargetID}
                      tooltipName="Delete"
                      tooltipContent="Delete"
                    />
                  </div>
                </div>
              </td>
            </CRUDTableRow>
          ))}
        </tbody>

        <Pagination
          totalItems={totalItems}
          limit={limit}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </CRUDTable>

      {showCreateForm && (
        <Modal
          extraClass="small"
          modalHeading="Create Bundle Offer"
          setShowModalContent={setShowCreateForm}
        >
          <CreateBundleOffer
            triggerFetch={triggerFetch}
            setShowCreateForm={
              setShowCreateForm
            }
          />
        </Modal>
      )}

      {showUpdateForm && (
        <Modal
          extraClass="small"
          modalHeading="Update Bundle Offer"
          setShowModalContent={setShowUpdateForm}
        >
          <UpdateBundleOffer
            triggerFetch={triggerFetch}
            targetID={targetID}
            setShowUpdateForm={
              setShowUpdateForm
            }
          />
        </Modal>
      )}

      {showViewSection && (
        <Modal
          extraClass="small"
          modalHeading="Bundle Offer Details"
          setShowModalContent={
            setShowViewSection
          }
        >
          <ViewBundleOffer
            targetID={targetID}
          />
        </Modal>
      )}

      {showDeleteSection && (
        <Modal
          extraClass="small"
          modalHeading="Delete Bundle Offer"
          setShowModalContent={
            setShowDeleteSection
          }
        >
          <DeleteItem
            api={BUNDLE_OFFERS_API}
            triggerFetch={triggerFetch}
            targetID={targetID}
            setShowDeleteItem={
              setShowDeleteSection
            }
          />
        </Modal>
      )}
    </>
  );
}

export default BundleOffers;